import React, { Component } from 'react';
export default class ErrorPage extends Component {


    render() {
        return (
            <div className="form-holder">
                <div className="card">
                    <div className="card-heading">
                        <h1 className="card-title">
                            Error 404 Page not Found
                        </h1>
                    </div>
                    <div className="card-body">
                        <p>The page you are looking for could not be found. If the error persists, please contact us at <a href="mailto:info@t-rex.online">info@t-rex.online</a>.</p>
                    </div>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/pages/ErrorPage.js